import React, {useEffect, useState} from "react";
import Modal from 'react-bootstrap/Modal';
import BodyHeader from "./ModalContent/Header";
import BodyForm from "./ModalContent/Form";
import {useTranslation, withTranslation} from "react-i18next";
import axios from "../../../axios-defaults";
import {toast} from "react-toastify";
import Spinner from "../../UI/Spinner";
import Alert from "../../UI/Alerts/Alert";

const InvoiceReview = (props) => {

    const {t, i18n} = useTranslation();
    const hideInvoiceReviewHandler = () => {
        props.hideInvoiceReview(false);
    }
	const [loading, setLoading] = useState(false);
	const [accountExist, setAccountExist] = useState(false);

	const getAccountExist = async() => {
		await axios.post(`/dataverse/account/exists`)
			.then(response => {
				if (response.data === 1) {
					setAccountExist(true)
				} else {
					setAccountExist(false)
				}
			}).catch(error => {
				console.log('[Account.js] : InvoiceReview ajax error in getAccountExist()',error.message);
			});
	}

	useEffect(async () => {
		setLoading(true);
		await getAccountExist();
		setLoading(false);
	}, []);

    return(
        <>
        { props.showInvoiceReview.open &&
			<Modal dialogClassName={"invoice-review-modal ultimate-modal ultimate-modal--full-container ultimate-modal--invoice-review-modal"}
                   show={props.showInvoiceReview.open}
                   backdrop="static"
                   scrollable="true"
                   onHide={() => hideInvoiceReviewHandler(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("invoice_review.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BodyHeader invoice={props.showInvoiceReview.data} />
					{loading ? <Spinner/> :
						<div>
							{accountExist ?
								<BodyForm invoice={props.showInvoiceReview.data} clickCancel={() => hideInvoiceReviewHandler()}/> :
								<div className="message message--danger">
									<div className="message__icon">
										<i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
									</div>
									<div className="message__content">
										{t('misc.account_not_found.line.one')} <br/>
										{t('misc.account_not_found.line.two')} <br/><br/>
										{t('misc.account_not_found.line.three')} <br/>
									</div>
								</div>
							}
						</div>
					}
                </Modal.Body>
            </Modal>
        }
        </>
    );
}

export default InvoiceReview;
